<div class="assignment-history" *ngIf="dataLoaded">
  <div class="bc-panel-header">
    <svg-icon icon="history-outline" class="bc-panel-header-icon"></svg-icon>
    <span class="bc-panel-header-text">{{ 'assignmentHistory.historyTitle' | translate }}</span>
  </div>

  <div class="assignment-history-item-list" *ngIf="!assignmentHistory.length">
    <div class="no-assignment-history">{{ (isClosedItem() ? 'assignmentHistory.noAssignmentHistoryForClosedItem' : 'assignmentHistory.noAssignmentHistoryForActiveItem') | translate }}</div>
  </div>

  <div class="assignment-history-item-list" *ngIf="assignmentHistory.length">
    <app-assignment-history-item *ngFor="let historyItem of assignmentHistory; let last = last;"
                                 [assignmentHistoryModel]="historyItem"
                                 [collapsible]="hasMoreThanOneAssignmentHistoryItem()"
                                 [collapsed]="hasMoreThanOneAssignmentHistoryItem() && !last">
    </app-assignment-history-item>
  </div>
</div>
<app-loading *ngIf="!dataLoaded" class="loading-container"></app-loading>
